import { Box, Paper } from '@mui/material';
import React from 'react';
import type { Category } from '../../../../../workflows/quotes/prime-x/api/types/rater-x-preset';
import { Show } from '../../../../../../components/Show';
import CoverageSubgroupTitle from '../../../../../workflows/quotes/prime-x/components/coverages/CoverageSubgroupTitle';
import CoverageXLineItem from './CoverageXLineItem';
import type { Languages } from '../../../../../../i18n/i18n.language-config';
import GroupCoverageHeader from './GroupCoverageHeader';
import { useHasVisibleCoverages } from '../hooks/useHasVisibleCoverages';

interface ICoverageCategory {
  coveragesByCategory: Category;
  language: Languages;
}

const CoverageCategory = ({
  coveragesByCategory,
  language,
}: ICoverageCategory) => {
  const hasVisibleCoverages = useHasVisibleCoverages(coveragesByCategory);

  if (!hasVisibleCoverages) {
    return null;
  }

  return (
    <Box>
      <Paper elevation={4}>
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: '2fr repeat(4, minmax(auto, 1fr))',
            alignItems: 'stretch',
            justifyItems: 'stretch',
            containerType: 'inline-size',
            '& > div': {
              p: 2,
            },
            '& > p': {
              p: 2,
            },
            '@container (max-width: 840px)': {
              '& > div': {
                p: 1,
              },
              '& > p': {
                p: 1,
              },
            },
          }}
        >
          <GroupCoverageHeader title={coveragesByCategory.title} />
          {coveragesByCategory.groups.map((_group) => {
            return (
              <React.Fragment key={_group.title}>
                <Show when={coveragesByCategory.groups.length > 1}>
                  <CoverageSubgroupTitle sx={{ gridColumn: '1/6' }}>
                    {_group.title}
                  </CoverageSubgroupTitle>
                </Show>

                {_group.coverages
                  .filter((_cov) => !_cov.isHidden || _cov.isSelected)
                  .map((_coverage, index) => (
                    <CoverageXLineItem
                      key={_coverage.id}
                      raterXCoverage={_coverage}
                      language={language}
                      isOdd={index % 2 !== 0}
                    />
                  ))}
              </React.Fragment>
            );
          })}
        </Box>
      </Paper>
    </Box>
  );
};

export default CoverageCategory;
